import { api } from "@/APIRequests";

export function handleFeatureFlagError(error, flagName, isEnabled) {
  const data = { enabled: isEnabled, flag_name: flagName };
  const options = { params: { showLoader: false } };

  api.featureFlag.post_feature_flag_error({ data, options });
  throw error;
}
